import { useLocation } from 'react-router-dom';

export const usePageInfo = () => {
  const pathname = useLocation().pathname;

  return {
    isAdminPage: pathname.includes('/admin'),
    isTrashPage:
      pathname.includes('/trash') || pathname.includes('/trash_explorer'),
  } as const;
};
